import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { CcwStepsList } from '../shared/CcwStepsList';
import { SectionHeading } from '../ui/SectionHeading';
import { ButtonLink } from '../ui/ButtonLink';
export function CcwNotice() {
  return <div className="flex gap-4 rounded-[4px] border-l-4 border-accent bg-mist p-5 md:p-6" data-id="element-133" data-mp="18pi36r5gtvhm">
      <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-134" data-mp="1dloylq08jolb" />
      <p className="text-[15px] leading-relaxed text-ink" data-id="element-135" data-mp="g0awh4vuxzla">
        <strong className="font-semibold" data-id="element-136" data-mp="kxb2jfspj2ce">Nevada is not a constitutional carry state.</strong> Out-of-state, military or law-enforcement training does not qualify.
      </p>
    </div>;
}
export function CcwExplainer() {
  return <section className="gutter section bg-white" aria-labelledby="ccw-how-title" data-id="element-137" data-mp="u02f5ixbk45m">
      <SectionHeading id="ccw-how-title" title="How to Get Your Nevada CCW" intro="Four steps from first class to legal carry." action={<ButtonLink to="/ccw-permits" variant="outline-dark" data-id="element-139" data-mp="331czqxeukgvr">
            Full CCW Permit Guide
          </ButtonLink>} data-id="element-138" data-mp="21b186qzh5yo5" />
      <div className="mt-14" data-id="element-140" data-mp="2y31oqjctg0by">
        <CcwStepsList data-id="element-141" data-mp="2xznpvl3d2999" />
      </div>
      <div className="mt-12 grid gap-4 lg:grid-cols-[1fr_auto] lg:items-center" data-id="element-142" data-mp="2t247c8zmrabi">
        <CcwNotice data-id="element-143" data-mp="2p124li6i8g4s" />
        <p className="text-xs text-steel lg:pl-6" data-id="element-144" data-mp="2p1ts05py77jz">Not legal advice.</p>
      </div>
    </section>;
}